/** Shared field wiring/styling, kept out of the component modules so those stay
 *  component-only (react-refresh) and so hint/error ids cannot drift apart. */

export function describedBy(id: string, hint?: unknown, error?: unknown): string | undefined {
  if (error) return `${id}-error`
  if (hint) return `${id}-hint`
  return undefined
}

/* Soft-boxed field: 1px outline-variant that turns Oroshi Blue on focus. */
export const CONTROL_BASE =
  'w-full rounded-lg border bg-surface-container-lowest px-4 py-3 font-body-md text-body-md text-on-surface transition-colors placeholder:text-outline focus:outline-none focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50'

export function controlTone(hasError: boolean): string {
  return hasError
    ? 'border-error focus:border-error focus:ring-error'
    : 'border-outline-variant focus:border-primary focus:ring-primary'
}
